// extracted by mini-css-extract-plugin
export default {"form":"TaskForm_form__5FtYe","field":"TaskForm_field__uY1TH"};